import { createSlice } from '@reduxjs/toolkit';
import { fetchUserStatistics, fetchUserBalanceHistory } from '../thunks/userStatisticsThunks.js';
import { updateUserBalance } from '../thunks/balanceThunks.js';

const initialState = {
    isLoading: false,
    maxPageNumber: 0,
    statistics: [],
    userHistory: {
        maxPageNumber: 0,
        balanceHistory: [],
        loading: false,
        userId: null,
        error: null,
    },
};

const balanceSlice = createSlice({
    name: 'userStatistics',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserStatistics.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.isLoading = false;
            })
            .addCase(updateUserBalance.fulfilled, (state, action) => {
                const { id, balance } = action.payload;

                state.statistics = state.statistics
                    .reduce((arr, cur) => {
                        if (cur.id === id) {
                            return [...arr, { ...cur, balance }];
                        }
                        return [...arr, cur];
                    }, [])
                    .sort((f, s) => s.balance - f.balance);

                state.isLoading = false;
            })
            .addCase(fetchUserBalanceHistory.pending, (state, action) => {
                state.userHistory.loading = true;
                state.userHistory.userId = action.meta.arg.userId;
                state.userHistory.error = null;
            })
            .addCase(fetchUserBalanceHistory.fulfilled, (state, action) => {
                const { balanceHistory, maxPageNumber, page } = action.payload;

                if (page === 0) {
                    state.userHistory.balanceHistory = balanceHistory;
                } else {
                    state.userHistory.balanceHistory = [...state.userHistory.balanceHistory, ...balanceHistory];
                }

                state.userHistory.maxPageNumber = maxPageNumber;
                state.userHistory.loading = false;
            })
            .addCase(fetchUserBalanceHistory.rejected, (state, action) => {
                state.userHistory.loading = false;
                state.userHistory.error = action.payload || action.error?.message;
            })
            .addMatcher(
                (action) => [fetchUserStatistics.pending.type, updateUserBalance.pending.type].includes(action.type),
                (state) => {
                    state.isLoading = true;
                },
            )
            .addMatcher(
                (action) => [fetchUserStatistics.rejected.type, updateUserBalance.rejected.type].includes(action.type),
                (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload || action.error?.message;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default balanceSlice.reducer;
